import { NotFoundError } from 'helpers/errors'
import { exists } from 'helpers/exists'
import { redirect } from 'helpers/navigation'
import { FetchProps } from 'helpers/redial'
import { getOutfitSlugWithIdolSlug, outfitUrl } from 'helpers/slug'
import { when } from 'mobx'
import { OUTFIT_SET } from 'services/sets/outfits'
import { GenderType } from 'store/features/user/types'

export default {
  fetch: async ({
    store,
    params: { outfitSlug, outfitId },
    query,
    ssr,
    nodeResponse,
    service,
  }: FetchProps) => {
    const { odp } = store
    odp.startLoading()

    const outfit = await odp.fetchOutfitById(outfitId)

    if (ssr) {
      await store.user.setGenderAndLoadNavigation(outfit.gender, {
        enforceOnClient: true,
      })
      nodeResponse.setHeader('X-No-Cache', 'true')
    }

    const outfitSlugWithIdolSlug = getOutfitSlugWithIdolSlug({
      outfitSlug: outfit.slug,
      idolSlug: outfit.idol.slug,
    })
    if (outfitSlug !== outfit.slug && outfitSlug !== outfitSlugWithIdolSlug) {
      const correctUrl = outfitUrl({
        outfitSlug: outfit.slug,
        idolSlug: outfit.idol.slug,
        outfitId,
      })

      odp.stopLoading()

      if (correctUrl) {
        throw redirect(correctUrl, query, {
          replaceState: true,
        })
      }
      throw new NotFoundError(`Outfit ${outfitSlug} not found.`)
    }

    const idolOutfits = await store.service.outfits.requestOutfitRecoByIdolId(
      outfit.idolId,
      {
        perPage: 20,
        gender: outfit.gender as GenderType,
        excludeOutfitId: outfit.id,
      },
      OUTFIT_SET,
    )

    const idolOutfitIds = idolOutfits.outfits.map(outfit => outfit.id)

    odp.setIdolOutfitIds(idolOutfitIds)

    const primeOutfitId =
      idolOutfitIds.length > 0
        ? idolOutfitIds.find(id => id !== outfit.id)
        : null

    if (exists(primeOutfitId)) {
      const primeOutfit = service.outfits.getById(primeOutfitId)

      if (!primeOutfit) {
        throw new NotFoundError(`Prime Outfit ${primeOutfitId} not in store.`)
      }

      await service.products.requestProductsByIds(primeOutfit.productIds)

      odp.setPrimeOutfitId(primeOutfitId)
    }
    odp.stopLoading()
  },

  defer: async ({ store }: FetchProps) => {
    when(() => exists(store.odp.outfitId)).then(() => {
      store.odp.fetchStoryReco()

      if (!exists(store.odp.outfitId)) {
        throw new NotFoundError(`Outfit should be loaded but isn't.`)
      }

      store.recommendations.fetchTrendingOutfits({
        limit: 20,
        excludeOutfitId: store.odp.outfitId,
      })
    })
  },
}
